(ns practitest.frontend.components.confirmation
  (:require
   [practitest.frontend.pt-ts-bridge :as pt-ts :refer [ConfirmationModal]]
   [practitest.frontend.common.i18n :refer [get-translation]]))

(defn confirm
  "This function generates a modal confirmation dialog with customizable options.

  Parameters:
  :show? - An atom containing a boolean indicating whether the modal should be displayed.
  :title - The title of the modal.
  :body - The body text of the modal.
  :on-yes - The function to be called when the 'Yes' button is clicked.
  :on-no - The function to be called when the 'No' button is clicked.
  :yes-label - The label for the 'Yes' button. Defaults to the translation of 'confirmation.yes' or 'Yes'.
  :no-label - The label for the 'No' button. Defaults to the translation of 'confirmation.no' or 'No'."
  [{:keys [show? title body on-yes on-no yes-label no-label test-id dialog-test-id]
    :or {yes-label (get-translation "generic.button.yes" "Yes")
         no-label (get-translation "generic.button.no" "No")}}]
  [:> ConfirmationModal
            {:show @show?
             :onHide on-no
             :title title
             :body body
             :on-yes on-yes
             :on-no on-no
             :yes-label yes-label
             :no-label no-label
             :yesTestId test-id
             :dialogTestId dialog-test-id}])
